
import { Container, Row, Col, Card } from "react-bootstrap"
import "../pages/styled/About.css"
import Aboutbanner from "../assets/productsec/Aboutbanner.jpeg";
function About() {
  return (
    <>
  <div
  className="about-header"
  style={{
  backgroundImage: `url(${Aboutbanner})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  }}
>
  <div className="header-content">
    <h1
      className="header-title"
      style={{
        fontSize: "3rem",
        fontWeight: "bold",
        color: "#fff",
        textTransform: "uppercase",
      }}
    >
      ABOUT US
    </h1>
  </div>
</div>


      <Container className="py-5">
        <Row className="mb-5 align-items-center">
          <Col md={6}>
            <h2 className="section-title">Best Cleaning Services in Chennai</h2>
            <div className="divider"></div>
            <p className="text-muted">
              SunShiny Cleaning Services, established in 2010, is a premier provider of professional cleaning and
              housekeeping services in Chennai. With over a decade of experience, we specialize in delivering
              exceptional cleaning solutions for residential, commercial, and industrial clients.
            </p>
            <p className="text-muted">
              Our mission is to create cleaner, healthier environments through professional cleaning services that
              exceed client expectations. We combine advanced cleaning techniques with eco-friendly products to deliver
              superior results while minimizing environmental impact.
            </p>
          </Col>
          <Col md={6}>
            <img
              src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
              alt="Professional Cleaning Team"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>

        <div className="bg-primary text-white p-4 p-md-5 rounded mb-5">
          <Row>
            <Col md={6} className="mb-4 mb-md-0">
              <h2 className="fw-bold mb-3">Vision</h2>
              <p>
                To be the leading cleaning service provider in Chennai, recognized for our commitment to excellence,
                innovation, and environmental responsibility. We aim to set industry standards by delivering reliable,
                high-quality cleaning solutions that create healthier living and working environments.
              </p>
            </Col>
            <Col md={6}>
              <h2 className="fw-bold mb-3">Mission</h2>
              <p>
                Our mission is to provide exceptional cleaning services that enhance the quality of life for our
                clients. By employing trained professionals, using eco-friendly products, and implementing efficient
                cleaning processes, we strive to exceed expectations and build lasting relationships with our clients.
              </p>
            </Col>
          </Row>
        </div>

        <h2 className="section-title text-center">Our Core Values</h2>
        <div className="divider mx-auto mb-5"></div>
        <Row className="g-4">
          <Col md={6} lg={4}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center mb-3"
                  style={{ width: "50px", height: "50px" }}
                >
                  <i className="bi bi-people-fill fs-4"></i>
                </div>
                <Card.Title className="fw-bold">Customer Satisfaction</Card.Title>
                <Card.Text className="text-muted">
                  We prioritize understanding and fulfilling the unique needs of our clients, ensuring complete
                  satisfaction with every service.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center mb-3"
                  style={{ width: "50px", height: "50px" }}
                >
                  <i className="bi bi-award-fill fs-4"></i>
                </div>
                <Card.Title className="fw-bold">Excellence</Card.Title>
                <Card.Text className="text-muted">
                  We strive for the highest standards in every cleaning project, paying attention to detail and
                  delivering consistent quality.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center mb-3"
                  style={{ width: "50px", height: "50px" }}
                >
                  <i className="bi bi-shield-fill-check fs-4"></i>
                </div>
                <Card.Title className="fw-bold">Reliability</Card.Title>
                <Card.Text className="text-muted">
                  Our clients can depend on us to deliver consistent, high-quality cleaning services on schedule, every
                  time.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center mb-3"
                  style={{ width: "50px", height: "50px" }}
                >
                  <i className="bi bi-leaf-fill fs-4"></i>
                </div>
                <Card.Title className="fw-bold">Environmental Responsibility</Card.Title>
                <Card.Text className="text-muted">
                  We use eco-friendly cleaning products and sustainable practices to minimize our environmental
                  footprint.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center mb-3"
                  style={{ width: "50px", height: "50px" }}
                >
                  <i className="bi bi-lightbulb-fill fs-4"></i>
                </div>
                <Card.Title className="fw-bold">Innovation</Card.Title>
                <Card.Text className="text-muted">
                  We continuously improve our cleaning methods by adopting new technologies and techniques for better
                  results.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="p-4">
                <div
                  className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center mb-3"
                  style={{ width: "50px", height: "50px" }}
                >
                  <i className="bi bi-people fs-4"></i>
                </div>
                <Card.Title className="fw-bold">Professionalism</Card.Title>
                <Card.Text className="text-muted">
                  Our team members are trained professionals who conduct themselves with integrity and respect in all
                  client interactions.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className="bg-primary text-white p-4 p-md-5 rounded text-center mt-5">
          <h2 className="fw-bold mb-4">Our Success Story</h2>
          <Row className="g-4">
            <Col xs={6} md={3}>
              <h3 className="display-4 fw-bold">5,000+</h3>
              <p className="fs-5">Projects Completed</p>
            </Col>
            <Col xs={6} md={3}>
              <h3 className="display-4 fw-bold">1,200+</h3>
              <p className="fs-5">Regular Clients</p>
            </Col>
            <Col xs={6} md={3}>
              <h3 className="display-4 fw-bold">50+</h3>
              <p className="fs-5">Cleaning Professionals</p>
            </Col>
            <Col xs={6} md={3}>
              <h3 className="display-4 fw-bold">10+</h3>
              <p className="fs-5">Years of Experience</p>
            </Col>
          </Row>
        </div>

        <section className="py-5">
          <h2 className="section-title text-center">Our Cleaning Process</h2>
          <div className="divider mx-auto mb-5"></div>
          <Row className="g-4">
            <Col md={3}>
              <div className="process-step text-center">
                <div className="process-icon">
                  <span>1</span>
                  <i className="bi bi-clipboard-check"></i>
                </div>
                <h4>Assessment</h4>
                <p>We evaluate your space and cleaning requirements</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="process-step text-center">
                <div className="process-icon">
                  <span>2</span>
                  <i className="bi bi-file-earmark-text"></i>
                </div>
                <h4>Planning</h4>
                <p>We create a customized cleaning plan for your needs</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="process-step text-center">
                <div className="process-icon">
                  <span>3</span>
                  <i className="bi bi-brush"></i>
                </div>
                <h4>Execution</h4>
                <p>Our team performs thorough cleaning services</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="process-step text-center">
                <div className="process-icon">
                  <span>4</span>
                  <i className="bi bi-check-circle"></i>
                </div>
                <h4>Quality Check</h4>
                <p>We ensure all cleaning meets our high standards</p>
              </div>
            </Col>
          </Row>
        </section>
      </Container>
    </>
  )
}

export default About

